import { render, staticRenderFns } from "./proceedings.vue?vue&type=template&id=0bfed228"
import script from "./proceedings.vue?vue&type=script&lang=js"
export * from "./proceedings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfed228')) {
      api.createRecord('0bfed228', component.options)
    } else {
      api.reload('0bfed228', component.options)
    }
    module.hot.accept("./proceedings.vue?vue&type=template&id=0bfed228", function () {
      api.rerender('0bfed228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedings.vue"
export default component.exports